<template>
  <slot />
</template>

<script>
import { ref, reactive, provide, readonly, watch } from 'vue';

export const CURRENT_IDX = 'CURRENT_IDX';
export const INCREMENT_INDEX = 'CURRENT_IDX/INCREMENT_INDEX';
export const DECREMENT_INDEX = 'CURRENT_IDX/DECREMENT_INDEX';
export const FIELD_VALUES = 'FIELD_VALUES';
export const SET_FIELD = 'FIELD_VALUES/SET_FIELD';

export default {
  setup() {
    const currentIdx = ref(0);
    const fieldValues = reactive({
      email: 'morty.smith@pm.me'
    });

    provide(CURRENT_IDX, readonly(currentIdx));
    provide(FIELD_VALUES, readonly(fieldValues));

    const incrementIndex = () => (currentIdx.value = currentIdx.value + 1);
    const decrementIndex = () => (currentIdx.value = currentIdx.value - 1);
    const setField = (key, value) => {
      fieldValues[key] = value;
    };

    provide(INCREMENT_INDEX, incrementIndex);
    provide(DECREMENT_INDEX, decrementIndex);
    provide(SET_FIELD, setField);

    watch(currentIdx, () => {
      console.log('currentIdx', currentIdx);
    });

    watch(fieldValues, () => {
      console.log('fieldValues', fieldValues);
    });
  }
};
</script>
